var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeciality2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:#707070;}.b{clip-path:url(#a);}.c{fill:#208ce1;stroke:#208ce1;stroke-width:0.2px;}.d{fill:#e2e8f3;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 50,
    height: 50,
    transform: "translate(-2874 -4030)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(2874 4030)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2875.863 -4039.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M17.417,12.5a2.527,2.527,0,1,0,2.527,2.527A2.522,2.522,0,0,0,17.417,12.5Zm0,1.166a1.361,1.361,0,1,1-1.361,1.361A1.352,1.352,0,0,1,17.417,13.666Zm15.511.35a8.719,8.719,0,0,0-8.708,8.709v2.8a.6.6,0,0,0,.583.583h.622A8.719,8.719,0,0,0,34.135,17.4V14.6a.6.6,0,0,0-.583-.583Zm0,1.166h.039V17.4a7.55,7.55,0,0,1-7.542,7.542h-.039V22.725A7.549,7.549,0,0,1,32.929,15.183Zm12.208,1.555a1.47,1.47,0,0,0-1.088.466,1.535,1.535,0,0,0-.234,1.866L26.087,35.788l-.039.039H5.366a2.484,2.484,0,0,0-1.866.855,2.6,2.6,0,0,0-.622,1.983,20.034,20.034,0,0,0,39.81,0,2.6,2.6,0,0,0-.623-1.983,2.482,2.482,0,0,0-1.866-.855h-3.3L48.285,23.5a1.77,1.77,0,0,0,.778.194,1.413,1.413,0,0,0,1.089-.467,1.549,1.549,0,0,0,0-2.216L46.225,17.2A1.535,1.535,0,0,0,45.136,16.738Zm-39.033.7a.6.6,0,0,0-.583.583v4A12.187,12.187,0,0,0,17.689,34.194h.855a.6.6,0,0,0,.583-.583V29.645A12.186,12.186,0,0,0,6.959,17.477H6.1ZM45.1,17.9a.352.352,0,0,1,.272.116l3.849,3.849a.391.391,0,0,1,.038.583.375.375,0,0,1-.544,0l-.156-.156L44.981,18.72l-.155-.156a.376.376,0,0,1,0-.544A.352.352,0,0,1,45.1,17.9Zm-38.411.739h.273A10.976,10.976,0,0,1,18,29.645v3.421h-.311a11.018,11.018,0,0,1-11-11Zm37.867,1.282,2.8,2.8-12.091,13.1H27.68Zm-18.972,8.9a1.944,1.944,0,1,0,1.944,1.944A1.925,1.925,0,0,0,25.582,28.828Zm0,1.166a.778.778,0,1,1-.778.778A.78.78,0,0,1,25.582,29.995ZM5.366,36.954H40.121a1.5,1.5,0,0,1,1.012.5,1.376,1.376,0,0,1,.349,1.089A18.858,18.858,0,0,1,4,38.509a1.422,1.422,0,0,1,.349-1.089A1.31,1.31,0,0,1,5.366,36.954Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M-2865.422-3991.773s13.063,12.662,26.391-.917c-3.724.847-6.5,3.1-13.1,3.331A38.116,38.116,0,0,1-2865.422-3991.773Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeciality2);
export default __webpack_public_path__ + "static/media/speciality2.b08ad7a81aa4ca062cb45bb3c9b6eee2.svg";
export { ForwardRef as ReactComponent };